import { Component, Input } from '@angular/core';
import { ConsultantCommentaryModalInput } from '../../services/modal/modal';

@Component({
  selector: 'libero-draft-commentary',
  templateUrl: './draft-commentary.component.html',
  styleUrls: ['./draft-commentary.component.scss'],
  standalone: false
})
export class DraftCommentaryComponent {
  @Input() public show: boolean | null = null;
  @Input() public consultCommentary: ConsultantCommentaryModalInput | null = null;
}
